import type Alpine from "alpinejs";
import { isDialogActive, isInDialog } from "../context";

const KEY_ALIASES: Record<string, string> = {
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright",
  esc: "escape",
};

const keydown: Alpine.DirectiveCallback = (el, directive, utilities) => {
  const rawKey = directive.modifiers[0]?.toLowerCase() ?? "";
  const key = KEY_ALIASES[rawKey] ?? rawKey;
  const expression = directive.expression;

  if (!key || !expression) return;

  const isDialogScoped = isInDialog(el);
  const evaluate = utilities.evaluateLater<unknown>(expression);

  function onKeyDown(e: KeyboardEvent) {
    if (e.key.toLowerCase() !== key) return;
    if (isDialogScoped !== isDialogActive()) return;

    evaluate(() => {}, { scope: { $event: e }, params: [e] } as any);
  }

  document.addEventListener("keydown", onKeyDown);
  utilities.cleanup(() => document.removeEventListener("keydown", onKeyDown));
};

export default keydown;
